(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/analytics-promotion/assets/javascripts/observeimpression.js') >= 0) return;  svs.modules.push('/components/components/analytics-promotion/assets/javascripts/observeimpression.js'); "use strict";

(function (window, document, svs, $) {
  'use strict';

  var visualElements = new Set();
  var observer;
  var stackEventsTimeout;
  var promoEventStacker = {};
  svs.components = svs.components || {};
  svs.components.analytics = svs.components.analytics || {};
  var logger = svs.core.log.getLogger('components:analytics-promotion');
  var observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: [0.4, 0.5]
  };
  var TIME_TO_IMPRESSION = 1000;
  var stackEventsDelay = 400;

  svs.components.analytics.batchPromoImpression = function (options, label) {
    if (svs.core.detect.feature('ft-no-batch-impressions')) {
      var evt = {
        event: 'promoImpression',
        component: {
          componentType: 'promo',
          componentID: options.name,
          componentName: options.title,
          componentPosition: options.position || 'unknownarea'
        }
      };

      if (label) {
        evt.eventInfo = {
          eventName: label
        };
      }

      window.dataLayerPush(evt);
      window.eddl.eddlPush('promoView', {
        id: evt.component.componentID,
        name: evt.component.componentName,
        position: evt.component.componentPosition
      });
    } else {
      stackAnalyticsEvents({
        componentType: 'promo',
        componentID: options.name,
        componentName: options.title,
        componentPosition: options.position || 'unknown'
      }, label);
    }
  };

  function stackAnalyticsEvents(evt, label) {
    if (!promoEventStacker[label]) {
      promoEventStacker[label] = {
        event: 'promoImpression',
        component: []
      };

      if (label) {
        promoEventStacker[label].eventInfo = {
          eventName: label
        };
      }
    }

    promoEventStacker[label].component.push(evt); 

    if (!stackEventsTimeout) {
      stackEventsTimeout = setTimeout(function () {
        Object.keys(promoEventStacker).forEach(function (eventStack) {
          window.dataLayerPush(promoEventStacker[eventStack]);
          window.eddl.eddlPush('promoView', {
            id: promoEventStacker[eventStack].componentID,
            name: promoEventStacker[eventStack].componentName,
            position: promoEventStacker[eventStack].componentPosition
          });
        });
        promoEventStacker = {};
        stackEventsTimeout = null;
      }, stackEventsDelay);
    }
  }

  function setupImpressionTracking() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(handleIntersection, observerOptions);

      try {
        var elementsToTrack = document.querySelectorAll('[data-impression]');

        for (var i = 0; i < elementsToTrack.length; i++) {
          observer.observe(elementsToTrack[i]);
        }
      } catch (e) {
        logger.warn("Unexpected error:".concat(e.message));
      }
    } else {
    }
  }

  function SendImpression(element) {
    var comp = {
      componentType: 'promo',
      componentID: element.dataset.track,
      componentName: element.dataset.track,
      componentPosition: element.dataset.areaName || 'unknownarea'
    };
    var evt = {
      event: 'promoImpression',
      component: [comp]
    };

    if (element.dataset.label) {
      evt.eventInfo = {
        eventName: element.dataset.label
      };
    }

    window.dataLayerPush(evt);
    window.eddl.eddlPush('promoView', {
      id: comp.componentID,
      name: comp.componentName,
      position: comp.componentPosition
    }); 

    var msg = new svs.core.log.Message(svs.core.log.MessageType.event);
    msg.eventCategory = 'Impression';
    msg.eventAction = "[".concat(comp.componentPosition, "]");
    msg.eventLabel = comp.componentName;
    msg.eventValue = 1;
    svs.core.log.track('svs.components.analytics', msg);
    observer.unobserve(element);
    element.removeAttribute('data-impression');
  }

  function timeInViewport(element) {
    return setTimeout(function () {
      if (visualElements.has(element)) {
        SendImpression(element);
        visualElements.delete(element);
      }
    }, TIME_TO_IMPRESSION);
  }

  function handleIntersection(entries) {
    entries.forEach(function (entry) {
      var el = entry.target;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        visualElements.add(el);
        timeInViewport(el);
      } else {
        visualElements.delete(el);
      }
    });
  } 


  svs.components.analytics.testPromoImpression = function (element) {
    setupImpressionTracking();
    SendImpression(element);
  }; 


  $(function () {
    $(window).on('load', setupImpressionTracking);
  }); 

  $(window).on('unload', function () {
    $(window).off('load', setupImpressionTracking);
  });
})(window, window.document, svs, $);
 })(window);